import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ModalCloseButton from './ModalCloseButton';
import '../styles/components/whySignUpModal.css';
import SafeMarkdown from './SafeMarkdown';

interface WhySignUpModalProps {
  onClose: () => void;
}

const WhySignUpModal: React.FC<WhySignUpModalProps> = ({ onClose }) => {
  const navigate = useNavigate();
  const [markdownContent, setMarkdownContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  // Load markdown content
  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const response = await fetch('/whysignup/content.md');
        if (response.ok) {
          const content = await response.text();
          setMarkdownContent(content);
        } else {
          setMarkdownContent('# Why Wandering Sock?\n\nContent not available.');
        }
      } catch (error) {
        console.error('Failed to load why sign up content:', error);
        setMarkdownContent('# Why Wandering Sock?\n\nFailed to load content.');
      }
      setLoading(false);
    };
    
    loadMarkdown();
  }, []);

  const handleSignUp = () => {
    navigate('/signup');
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="why-signup-overlay" onClick={handleOverlayClick}>
      <div className="why-signup-modal">
        {/* Content */}
        <div className="why-signup-content">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              {/* Top CTA Button with Close Button */}
              <div className="why-signup-header">
                <button className="why-signup-cta why-signup-cta-top" onClick={handleSignUp}>
                  Sign Up for Free
                </button>
                <ModalCloseButton onClick={onClose} />
              </div>

              {/* Markdown Content */}
              <div className="why-signup-markdown markdown-content">
                <SafeMarkdown>{markdownContent}</SafeMarkdown>
              </div>

              {/* Bottom CTA Button */}
              <button className="why-signup-cta" onClick={handleSignUp}>
                Sign Up for Free
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WhySignUpModal;
